module.exports = __webpack_public_path__ + "img/SISGEOWEBSALA10.6dd4f850.svg";